var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{staticClass:"sliders sliderstop",attrs:{"interval":3000,"height":_vm.clientHeight,"autoplay":true},on:{"change":_vm.changeHandle}},_vm._l((_vm.banners),function(banner){return _c('el-carousel-item',{key:banner.name,style:(banner.style)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }